module.exports = __webpack_public_path__ + "static/img/bg-en.8ea43a81.png";